
















































import Vue from 'vue';
import CountWidget from '@/components/dashboard/CountWidget.vue';
import { ICountWidgetData } from '@/types/dashboard';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'DashboardCounts',
  components: { CountWidget },

  mounted() {
    this.loadRunningCampaignsCount();
    this.loadSpendCount();
    this.loadImpressionsCount();
    this.loadConversionsCount();
  },

  computed: {
    ...mapGetters({
      getRunningCampaignsCount: 'dashboard/getRunningCampaignsCount',
      getSpendCount: 'dashboard/getSpendCount',
      getImpressionsCount: 'dashboard/getImpressionsCount',
      getConversionsCount: 'dashboard/getConversionsCount',
    }),
    refs(): any {
      return this.$refs;
    },
    runningCampaigns(): ICountWidgetData {
      return {
        ref: 'runningCampaigns',
        title: String(this.$t('pages.dashboard.runningCampaigns')),
        link: '/campaigns?filter=1&status=_active',
        today: this.getRunningCampaignsCount.data,
        loader: this.getRunningCampaignsCount.loadData.loader
      };
    },
    spend(): ICountWidgetData {
      return {
        ref: 'spend',
        title: String(this.$t('pages.dashboard.spend')),
        link: '/statistics/campaign',
        today: this.getSpendCount.data.today,
        yesterday: this.getSpendCount.data.yesterday,
        loader: this.getSpendCount.loadData.loader
      };
    },
    impressions(): ICountWidgetData {
      return {
        ref: 'impressions',
        title: String(this.$t('pages.dashboard.impressions')),
        link: '/statistics/campaign',
        today: this.getImpressionsCount.data.today,
        yesterday: this.getImpressionsCount.data.yesterday,
        loader: this.getImpressionsCount.loadData.loader
      };
    },
    conversions(): ICountWidgetData {
      return {
        ref: 'conversions',
        title: String(this.$t('pages.dashboard.conversions')),
        link: '/statistics/campaign',
        today: this.getConversionsCount.data.today,
        yesterday: this.getConversionsCount.data.yesterday,
        loader: this.getConversionsCount.loadData.loader
      };
    },
  },

  methods: {
    loadRunningCampaignsCount() {
      this.$store
        .dispatch('dashboard/loadRunningCampaignsCount')
    },
    loadSpendCount() {
      this.$store
        .dispatch('dashboard/loadSpendCount')
    },
    loadImpressionsCount() {
      this.$store
        .dispatch('dashboard/loadImpressionsCount')
    },
    loadConversionsCount() {
      this.$store
        .dispatch('dashboard/loadConversionsCount')
    },
  },
});
